import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { photosShow } from '../../helpers/photosShow';
import { fileuploadDir } from '../../config';

// Assets
import mediumNoImage from './medium_no_image.png';
import largeNoImage from './large_no_image.jpeg';

const ListCoverPhoto = ({ coverPhoto, listPhotos, className, photoType, bgImage = false, children }) => {

    const [photo, setPhoto] = useState(null);

    useEffect(() => {
        if (listPhotos && listPhotos.length > 0) {
            let activePhoto = listPhotos[0].name;

            if (coverPhoto != null && coverPhoto !== undefined) {
                listPhotos.forEach((item) => {
                    if (item.id === coverPhoto) {
                        activePhoto = item.name;
                    }
                });
            }

            setPhoto(activePhoto);
        }
    }, [coverPhoto, listPhotos]);

    const imagePath = photosShow(fileuploadDir);
    let path = '';
    let source;

    if (photo !== null) {
        source = photo;
        if (photoType !== undefined) {
            path = `${imagePath}${photoType}_`;
        }
    } else {
        if (photoType === 'xx_large') {
            source = largeNoImage;
        } else {
            source = mediumNoImage;
        }
    }

    const style = { backgroundImage: `url(${path}${source})` };

    return bgImage ? (
        <div className={className} style={style}>
            {children}
        </div>
    ) : (
        <div className={className} style={style} />
    );
};

ListCoverPhoto.propTypes = {
    coverPhoto: PropTypes.number,
    listPhotos: PropTypes.array,
    className: PropTypes.string,
    bgImage: PropTypes.bool,
    photoType: PropTypes.string,
    children: PropTypes.node
};

export default ListCoverPhoto;
